import { render, staticRenderFns } from "./lrTenantNo.vue?vue&type=template&id=28836ab2&"
import script from "./lrTenantNo.vue?vue&type=script&lang=js&"
export * from "./lrTenantNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports